// extracted by mini-css-extract-plugin
export default {"host":"OrdersListView_host__+sMoD","noData":"OrdersListView_noData__K9Hck"};